<template>
    <v-data-table
        v-model="selected"
        :headers="headers"
        :items="users"
        :search="search"
        :single-select="singleSelect"
        show-select
        item-key="RequestProposal_id"
        sort-by="calories"
        class="elevation-1"
    >
        <template v-slot:top>
        <v-card>
            <v-card-title>
                <span class="headline">Filtro de Propuesta</span>
            </v-card-title>
            <v-card-text>
                <v-row>
                    <v-row>
                        <v-col cols="12" sm="6" md="5" offset-sm="1">
                            <v-autocomplete
                                v-model="modelOP"
                                :items="itemsOP"
                                :loading="isLoadingOP"
                                :search-input.sync="searchOpPoint"
                                color="black"
                                hide-no-data
                                hide-selected
                                clearable
                                item-text="inputText"
                                item-value="OpPoint_id"
                                label="Punto Operacional"
                                placeholder="Escribe para buscar"
                                prepend-icon="mdi-map-marker"
                                cache-items
                                return-object
                            ></v-autocomplete>
                        </v-col>
                        <v-col cols="12" sm="6" md="5" offset-sm="0">
                            <v-autocomplete v-if="supInd === false"
                                v-model="modelSup"
                                :items="items"
                                :loading="isLoading"
                                :search-input.sync="searchSupplier"
                                color="black"
                                hide-no-data
                                hide-selected
                                clearable
                                item-text="inputText"
                                item-value="MotherSupplier_id"
                                label="Proveedor Madre"
                                placeholder="Escribe para buscar"
                                prepend-icon="mdi-alpha-p-box"
                                cache-items
                                return-object
                            ></v-autocomplete>
                            <v-text-field v-if="supInd === true" v-model="modelSup2" label="Folio" :disabled="true"><v-icon slot="prepend" color="grey">mdi-account</v-icon></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="5" offset-sm="4">
                        <v-menu
                            v-model="menu2"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                            min-width="290px"
                        >
                            <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                                v-model="modelRecepDate"
                                clearable
                                label="Fecha De Turno Actual"
                                prepend-icon="mdi-calendar"
                                readonly
                                v-bind="attrs"
                                v-on="on"
                            ></v-text-field>
                            </template>
                            <v-date-picker v-model="modelRecepDate" @input="menu2 = false"></v-date-picker>
                        </v-menu>
                        </v-col>
                    </v-row>
                </v-row>
                <v-text-field
                    v-model="search"
                    append-icon="mdi-magnify"
                    label="Filtro"
                    single-line
                    hide-details
                ></v-text-field>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                    <v-btn color="primary" @click="close">Cancel</v-btn>
                    <v-btn color="primary" @click="getRequestProposal">Buscar</v-btn>
                    <v-btn color="primary" @click="aceptar">Aceptar</v-btn>
            </v-card-actions>
        </v-card>
        </template>
    </v-data-table>
</template>

<script>
import axios from 'axios'
export default {
    data: () => ({
        search: '',
        singleSelect: true,
        selected: [],
        //modelRecepDate: new Date().toISOString().substr(0, 10),
        modelRecepDate: null,
        menu2: false,
        headers: [
            { text: 'Propuesta ID', value: 'RequestProposal_id' },
            { text: 'Numero Pedido', value: 'VendorPurchaseOrder_Num' },
            { text: 'Punto Operacional ID', value: 'OpPoint_id' },
            { text: 'Punto Operacional Desc', value: 'OpPoint_Description' },
            { text: 'Fecha Propuesta', value: 'RequestProposal_Dt' },
            { text: 'Proveedor ID', value: 'MotherSupplier_id' },
            { text: 'Proveedor Desc', value: 'MotherSupplier_Desc' },
            { text: 'Fecha de Cierre', value: 'Closing_Dt' },
             { text: 'Fecha de Recepcion', value: 'Reception_Dt' }
        ],
        users: [],
        descriptionLimit: 60,
        ResultRows: [],
        entries: [],
        isLoading: false,
        modelSup: null,
        searchSupplier: null,
        user_type: String,
        ResultRowsOP: [],
        entriesOP: [],
        isLoadingOP: false,
        modelOP: null,
        searchOpPoint: null,
        ResultRowsOP: [],

        entriesSrc: [],
        isLoadingSrc: false,
        modelSrc: null,
        searchSrc: null,
        ResultRowsSrc: [],
        api_tool_url: process.env.VUE_APP_API_TOOL_URL,
        config: {
            headers: {
                //'Authorization': 'Bearer ' + sessionStorage.getItem('access_token'),
                "api-user": sessionStorage.getItem('ApiUser_id')
            }
        },
        supInd: false
    }),
     methods: {
        errorHandler(error) {
            if(error.response.data.message == 'Fuera de Horario para Turnar') {
                alert(error.response.data.message)
                this.$router.go("/")
            }
            else {
                alert(error.response.data.message)
            }
        },
        close() {
            this.$store.commit('updateClose', "C")
            this.$emit('close-dialog')
        },
        aceptar() {
            this.$store.commit('updateClose', "A")
            this.$store.commit('updateFilterDialog', this.selected[0])
            this.$emit('close-dialog')
        },
        getRequestProposal() {
            let filter = {}
            if (this.modelOP != null) {
                filter.OpPoint_id = this.modelOP.OpPoint_id
            }

            if (this.modelSup != null) {
                filter.MotherSupplier_id =  this.modelSup.MotherSupplier_id
            }

            if (this.modelRecepDate != null) {
                filter.Reception_Dt =  this.modelRecepDate
            }
            //let filter = { OpPoint_id: this.modelOP.OpPoint_id, MotherSupplier_id: this.modelSup.MotherSupplier_id }
            axios.post(this.api_tool_url + '/get_requestproposal', filter, this.config)
            .then(response => {
                this.users = response.data.ResultRows
            })
            .catch(error => {
                console.log(error)
                //alert(error.response.data.message)
            })
        }
     },
     computed: {
      fields () {
        if (!this.model) return []

        return Object.keys(this.model).map(key => {
          return {
            key,
            value: this.model[key] || 'n/a',
          }
        })
      },
      items () {
        return this.ResultRows.map(entry => {
        //   const Description = entry.Description.length > this.descriptionLimit
        //     ? entry.Description.slice(0, this.descriptionLimit) + '...'
        //     : entry.Description

        //   return Object.assign({}, entry, { Description })
        const inputText = entry.MotherSupplier_id + " - " + entry.MotherSupplier_Desc
        return Object.assign({}, entry, { inputText })
        //return entry
        })
      },
      itemsOP () {
        return this.ResultRowsOP.map(entry => {
        //   const Description = entry.Description.length > this.descriptionLimit
        //     ? entry.Description.slice(0, this.descriptionLimit) + '...'
        //     : entry.Description

        //   return Object.assign({}, entry, { Description })
        const inputText = entry.OpPoint_id + " - " + entry.OpPoint_Description
        return Object.assign({}, entry, { inputText })
        //return entry
        })
      },
      itemsSrc () {
        return this.ResultRowsSrc.map(entry => {
        //   const Description = entry.Description.length > this.descriptionLimit
        //     ? entry.Description.slice(0, this.descriptionLimit) + '...'
        //     : entry.Description

        //   return Object.assign({}, entry, { Description })
        const inputText = entry.RequestProposalSrc_id + " - " + entry.RequestProposalSrc_Desc
        return Object.assign({}, entry, { inputText })
        //return entry
        })
      },
    },

    watch: {
      searchSupplier (val) {
        // Items have already been loaded
        if (this.model != null || val == null) return
        //if (this.items.length > 0) return
        //if (val.length < 5 && val.length > 15) return

        // Items have already been requested
        //if (this.isLoading) return

        this.isLoading = true

        // Lazily load input items
        //fetch('https://api.publicapis.org/entries')
        //axios.get('https://api.publicapis.org/entries')
        let filter = {
            param1: {
                conlumnName: "MotherSupplier_Desc",
                value: val,
                like: true
            },
            param2: {
                conlumnName: "MotherSupplier_id",
                value: val.match(/(\d+)/) != null ? val.match(/(\d+)/)[0]: "",
                like: false
            },
        }
        axios.post(this.api_tool_url + '/get_mothersuppliers', filter, this.config)
          //.then(res => res.json())
          .then(res => {
            //console.log(res.data.ResultRows)
            //const { count, entries } = res.data.ResultRows
            const { ResultRows } = res.data
            //this.count = count
            //this.entries = entries
            this.ResultRows = ResultRows
          })
          .catch(error => {
            console.log(error)
            this.errorHandler(error)
          })
          .finally(() => (this.isLoading = false))
      },
      searchOpPoint (val) {
        // Items have already been loaded
        if (this.modelOP != null || val == null) return
        //if (this.items.length > 0) return
        //if (val.length < 5 && val.length > 15) return

        // Items have already been requested
        //if (this.isLoading) return

        this.isLoadingOP = true

        // Lazily load input items
        //fetch('https://api.publicapis.org/entries')
        //axios.get('https://api.publicapis.org/entries')
        let filter = {
            param1: {
                conlumnName: "OpPoint_Description",
                value: val,
                like: true
            },
            param2: {
                conlumnName: "OpPoint_id",
                value: val.match(/(\d+)/) != null ? val.match(/(\d+)/)[0]: "",
                like: false
            },
        }
        axios.post(this.api_tool_url + '/get_oppoint', filter, this.config)
          //.then(res => res.json())
          .then(res => {
            //console.log(res.data.ResultRows)
            //const { count, entries } = res.data.ResultRows
            const { ResultRows } = res.data
            //this.count = count
            //this.entries = entries
            this.ResultRowsOP = ResultRows
          })
          .catch(error => {
            console.log(error)
            this.errorHandler(error)
          })
          .finally(() => (this.isLoadingOP = false))
      },
      searchSrc (val) {
        // Items have already been loaded
        if (this.modelSrc != null || val == null) return
        //if (this.items.length > 0) return
        //if (val.length < 5 && val.length > 15) return

        // Items have already been requested
        //if (this.isLoading) return

        this.isLoadingSrc = true

        // Lazily load input items
        //fetch('https://api.publicapis.org/entries')
        //axios.get('https://api.publicapis.org/entries')
        let filter = {
            param1: {
                conlumnName: "RequestProposalSrc_Desc",
                value: val,
                like: true
            },
            param2: {
                conlumnName: "RequestProposalSrc_id",
                value: val.match(/(\d+)/) != null ? val.match(/(\d+)/)[0]: "",
                like: false
            },
        }
        axios.post(this.api_tool_url + '/get_proposalsrc', filter, this.config)
          //.then(res => res.json())
          .then(res => {
            //console.log(res.data.ResultRows)
            //const { count, entries } = res.data.ResultRows
            const { ResultRows } = res.data
            //this.count = count
            //this.entries = entries
            this.ResultRowsSrc = ResultRows
          })
          .catch(error => {
            console.log(error)
            this.errorHandler(error)
          })
          .finally(() => (this.isLoadingSrc= false))
      },
    },
    created () {
        //this.getRequestProposal()
        this.user_type = this.$store.state.user_type

        // if(this.$store.ApiUser_Supplier !== '-1') {
        //     this.ResultRows[0].MotherSupplier_id = this.$store.ApiUser_Supplier
        //     this.ResultRows[0].MotherSupplier_Desc = this.$store.MotherSupplier_Desc
        //     this.ResultRows[0].inputText = entry.MotherSupplier_id + " - " + entry.MotherSupplier_Desc

        //     this.items = this.ResultRows
        //     this.modelSup = this.$store.ApiUser_Supplier
        // }
    },
    mounted() {
        console.log(this.$store.state.ApiUser_Supplier)
        if(this.$store.state.ApiUser_Supplier !== '-1') {
            // this.ResultRows[0] = {}
            // this.ResultRows[0].MotherSupplier_id = this.$store.ApiUser_Supplier
            // this.ResultRows[0].MotherSupplier_Desc = this.$store.MotherSupplier_Desc
            // this.ResultRows[0].inputText = entry.MotherSupplier_id + " - " + entry.MotherSupplier_Desc

            // this.items = this.ResultRows
            this.modelSup2 = this.$store.state.ApiUser_Supplier + " - " + this.$store.state.MotherSupplier_Desc
            this.modelSup = {}
            this.modelSup.MotherSupplier_id = this.$store.state.ApiUser_Supplier
            this.supInd = true

        }
    },
}
</script>


// WEBPACK FOOTER //
// src/components/ProposalFilter.vue